import { render, staticRenderFns } from "./veJkyAdmin.vue?vue&type=template&id=c1be6bce&scoped=true"
import script from "./veJkyAdmin.vue?vue&type=script&lang=js"
export * from "./veJkyAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1be6bce",
  null
  
)

export default component.exports